module.exports = __webpack_public_path__ + "static/media/LTN GBR Care Infographic Desktop - GBR care -  24-05-2024 C.ce156eaf.gif";